import { Global } from '@emotion/react';
import { createInstance, HackleProvider } from '@hackler/react-sdk';
import { NotificationsProvider, reset, ThemeProvider } from '@inflearn/ds-react';
import {
  ModalsProvider as ModalsProviderNext,
  NotificationsProvider as NotificationsProviderNext,
  ThemeProvider as ThemeProviderNext,
} from '@inflearn/ds-react-next';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import type { ReactNode } from 'react';

import { CDN_URL, HACKLE_BROWSER_SDK_KEY } from './appConfig';
import globals from './styles/globals';

import '@inflearn/ds-react-next/mantine-core-styles.css';
import '@inflearn/ds-react-next/mantine-notifications-styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      useErrorBoundary: false,
      suspense: false,
    },
  },
});

const hackleClient = createInstance(HACKLE_BROWSER_SDK_KEY, {
  exposureEventDedupIntervalMillis: 1_000,
  pollingIntervalMillis: 30_000,
});

export default function AppProvider({ children }: { children: ReactNode }) {
  const user = {
    id: Cookies.get('deviceId'),
  };

  // reset props 에 해당 스타일을 적용하면, 앱쉘의 css 를 불러올 수 없어 주석 처리
  // const styles = {
  //   // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  //   '#for-ant-man': {
  //     ...reset,
  //   },
  // };

  return (
    <QueryClientProvider client={queryClient}>
      <HackleProvider hackleClient={hackleClient} user={user}>
        <ThemeProvider cdnLink={CDN_URL} withNormalizeCSS={false}>
          <NotificationsProvider />
          {/* v6 ThemeProvider가 이미 앱쉘과 공유하는 페이지의 리셋을 맡고 있으므로 v8 쪽 엘리먼트 리셋은 끈다 */}
          <ThemeProviderNext cdnLink={CDN_URL} reset={{}}>
            <NotificationsProviderNext />
            <ModalsProviderNext>
              <Global styles={[globals]} />
              {children}
            </ModalsProviderNext>
          </ThemeProviderNext>
        </ThemeProvider>
      </HackleProvider>
    </QueryClientProvider>
  );
}
